
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMemberTypeGrid extends Serenity.EntityGrid<PsMemberTypeRow, any> {
        protected getColumnsKey() { return PsMemberTypeColumns.columnsKey; }
        protected getDialogType() { return PsMemberTypeDialog; }
        protected getIdProperty() { return PsMemberTypeRow.idProperty; }
        protected getInsertPermission() { return PsMemberTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsMemberTypeRow.localTextPrefix; }
        protected getService() { return PsMemberTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}